import { createContext } from 'react';

const FeaturesContext = createContext({});

export default FeaturesContext;
